module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victoria Denault\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Victoria Denault")]), _vm._v(" loves long walks on the beach, cinnamon dolce lattes and writing angst-filled romance. She lives in LA but grew up in Montreal, which is why she is fluent in English, French, and hockey.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MTU3K1/Images/9781538727003.jpg?1732137008072",
      "alt": "This image is the cover for the book Game On, Hometown Players"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Game On, Hometown Players\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"I don't break hearts. I break headboards . . . \""), _c('br'), _c('br'), _vm._v(" When it comes to scoring in the pro hockey league, Alex Larue is crushing it-with the hot puck bunnies. He's the life of the party, the guy with all the jokes . . . and the one whose Party Guy mask keeps the real him well hidden. The last thing he needs is anyone finding out about his troubled past, or the nightmares that haunt him still. "), _c('br'), _c('br'), _vm._v(" Brie Bennett is less than impressed by Alex from the moment she meets him. And even though he insists on volunteering at the charity she runs, she doesn't trust him. He's hiding something...but so is she. She's not just the rich, privileged New York princess he thinks she is. The animosity between them is undeniably addictive and as their worlds keep colliding it becomes supercharged with something else - attraction. But if they stop playing games and let each other in, they both might lose.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grand Central Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0